// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import App from "./App";
import { captureFirstTouch, captureSessionLanding } from "./lib/attribution";
import { initGa4 } from "./lib/ga4";
import { isInterviewRespondPath } from "./lib/interviewRespond";

// The signed one-tap interview link carries an HMAC in the query string. GA4's
// automatic page_view sends `page_location` — the FULL URL, signature included —
// to Google. Skip analytics entirely on that route; it is a transactional
// surface reached from an inbox, not a marketing page worth measuring.
// (captureFirstTouch only stores pathname + utm_*, so it is left alone.)
const isSignedActionRoute =
  typeof window !== "undefined" && isInterviewRespondPath(window.location.pathname);

// Record first-touch marketing attribution (UTM, referrer, landing path) as
// early as possible, before any in-app navigation rewrites the URL.
captureFirstTouch();
// This visit's own landing (path, utm, referrer, in-app browser) for case-view
// source reporting. Same timing reason: before any URL rewrite.
captureSessionLanding();
// Optional GA4 (marketing). No-op unless REACT_APP_GA4_ID is set.
if (!isSignedActionRoute) initGa4();

// Google Search Console verification (meta-tag method). Set
// REACT_APP_GSC_VERIFICATION to the token Google gives you; it's prerendered
// into the homepage's static HTML. (Alternatively, drop the google<token>.html
// file Google provides into public/ — Netlify serves it at the site root.)
const gsc = (process.env.REACT_APP_GSC_VERIFICATION || "").trim();
if (gsc && typeof document !== "undefined" && !document.querySelector('meta[name="google-site-verification"]')) {
  const m = document.createElement("meta");
  m.setAttribute("name", "google-site-verification");
  m.setAttribute("content", gsc);
  document.head.appendChild(m);
}

// Google Fonts
const link = document.createElement("link");
link.rel = "stylesheet";
link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=DM+Mono:wght@400;500;700&display=swap";
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
